import React, { createContext, useState, useMemo } from 'react';
import { Counter } from '../types';
import { Contact } from '../../../Lib/Api/vendor';

type CounterContextType = {
  selectedCounter: Counter | null;
  setSelectedCounter: React.Dispatch<React.SetStateAction<Counter | null>>;
  getNextCounter: () => Counter | null;
  getPrevCounter: () => Counter | null;
  allCounters: Counter[];
  setAllCounters: (counters: Counter[]) => void;
  vendorId: string;
  setVendorId: (counters: string) => void;
  userId: number | null;
  setUserId: (counters: number) => void;
  contacts: Contact[];
};

export const CounterContext = createContext<CounterContextType | undefined>(
  undefined,
);

export function CounterProvider({
  children,
  contacts,
}: {
  children: React.ReactNode;
  contacts: Contact[];
}) {
  const [selectedCounter, setSelectedCounter] = useState<Counter | null>(null);
  const [allCounters, setAllCounters] = useState<Counter[]>([]);
  const [vendorId, setVendorId] = useState<string>('');
  const [userId, setUserId] = useState<number | null>(null);

  const value = useMemo(
    () => ({
      selectedCounter,
      setSelectedCounter,
      allCounters,
      setAllCounters,
      getNextCounter: () => {
        if (!selectedCounter || !allCounters.length) return null;
        const currentIndex = allCounters.findIndex(
          (counter) => counter.counter_id === selectedCounter.counter_id,
        );
        return allCounters[currentIndex + 1];
      },
      getPrevCounter: () => {
        if (!selectedCounter || !allCounters.length) return null;
        const currentIndex = allCounters.findIndex(
          (counter) => counter.counter_id === selectedCounter.counter_id,
        );
        return allCounters[currentIndex - 1];
      },
      setVendorId,
      vendorId,
      setUserId,
      userId,
      contacts,
    }),
    [selectedCounter, allCounters, contacts],
  );

  return (
    <CounterContext.Provider value={value}>{children}</CounterContext.Provider>
  );
}
